const formClientConstants = {
  INITIALIZE_FORM_CLIENT: 'INITIALIZE_FORM_CLIENT',
  INITIALIZE_FORM_CLIENT_SUCCESS: 'INITIALIZE_FORM_CLIENT_SUCCESS',
  INITIALIZE_FORM_CLIENT_ERROR: 'INITIALIZE_FORM_CLIENT_ERROR',
  SUBMIT_FORM: 'SUBMIT_FORM',
  SUBMIT_FORM_SUCCESS: 'SUBMIT_FORM_SUCCESS',
  SUBMIT_FORM_ERROR: 'SUBMIT_FORM_ERROR'
};

export default formClientConstants;
